import getProductDefaultConfiguration from "@helpers/products/getProductDefaultConfiguration";

import { transformCartItemsToGA } from "@analytics/google/utils/transformCartItemsToGA";

import type { Item } from "@typings/product/item";
import type { Product } from "@typings/product/product";

export const gaAddToCart = (cartItems: Product[]): void => {
  if (window) {
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "USD",
        items: transformCartItemsToGA(cartItems),
      },
    });
  }
};

export const gaRemoveFromCart = (cartItems: Product[]): void => {
  if (window) {
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: "remove_from_cart",
      ecommerce: {
        currency: "USD",
        items: transformCartItemsToGA(cartItems),
      },
    });
  }
};

export const gaViewItem = (item: Item): void => {
  if (window) {
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: "view_item",
      ecommerce: {
        currency: "USD",
        items: transformCartItemsToGA([
          { item, configuration: getProductDefaultConfiguration(item) },
        ]),
      },
    });
  }
};

export const gaViewCart = (cartItems: Product[]): void => {
  if (window) {
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: "view_cart",
      ecommerce: {
        currency: "USD",
        items: transformCartItemsToGA(cartItems),
      },
    });
  }
};

export const gaSelectItem = (item: Item): void => {
  if (window) {
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: "select_item",
      ecommerce: {
        currency: "USD",
        items: transformCartItemsToGA([
          { item, configuration: getProductDefaultConfiguration(item) },
        ]),
      },
    });
  }
};

export const gaPurchase = ({
  cartItems,
  user_data,
  ecommerce,
}: {
  cartItems: Product[];
  [key: string]: any;
}): void => {
  if (window) {
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: "purchase",
      ecommerce: {
        ...ecommerce,
        items: transformCartItemsToGA(cartItems),
      },
      user_data,
    });
  }
};

export const gaBeginCheckout = ({
  value,
  cartItems,
}: {
  cartItems: Product[];
  value: any;
}): void => {
  if (window) {
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: "begin_checkout",
      ecommerce: {
        value,
        currency: "USD",
        items: transformCartItemsToGA(cartItems),
      },
    });
  }
};

export const gaViewItemList = (items: Item[]): void => {
  if (window) {
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: "view_item_list",
      ecommerce: {
        currency: "USD",
        items: transformCartItemsToGA(
          items.map((item) => ({ item, configuration: getProductDefaultConfiguration(item) }))
        ),
      },
    });
  }
};

export const gaAddShippingInfo = ({
  cartItems,
  user_data,
  ecommerce,
}: {
  cartItems: Product[];
  [key: string]: any;
}): void => {
  if (window) {
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: "add_shipping_info",
      ecommerce: {
        ...ecommerce,
        shipping_tier: "FREE",
        items: transformCartItemsToGA(cartItems),
      },
      user_data,
    });
  }
};

export const gaAddPaymentInfo = ({
  cartItems,
  user_data,
  ecommerce,
}: {
  cartItems: Product[];
  [key: string]: any;
}): void => {
  if (window) {
    window.dataLayer?.push({ ecommerce: null });
    window.dataLayer?.push({
      event: "add_payment_info",
      ecommerce: {
        ...ecommerce,
        items: transformCartItemsToGA(cartItems),
      },
      user_data,
    });
  }
};
